// DS: C33C
/** Bottom section of a commission, containing related information
 *  https://zpl.io/2pvJMnN
 */ import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import classnames from 'classnames';
import { getDeviationTitle } from '../../../_helpers';
import Flex from '@wix/da-ds/pkg/Flex';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import UserLink from '../../../../User/Link';
import UserAvatar from '../../../../User/Avatar';
import Timestamp from '../../../../Timestamp';
import PriceBlock from './PriceBlock';
import s from './PanelC33C.scss';
const PanelC33C = (_param)=>{
    var { deviation, showAuthor = true, showTimestamp = true, addLink, className } = _param, priceProps = _object_without_properties(_param, [
        "deviation",
        "showAuthor",
        "showTimestamp",
        "addLink",
        "className"
    ]);
    const hasAuthor = deviation.author && showAuthor;
    const renderTitleWithLink = ()=>/*#__PURE__*/ React.createElement(DeviationLink, {
            deviation: deviation,
            className: classnames(s['title'], s['nowrap'])
        }, getDeviationTitle(deviation));
    const title = addLink ? renderTitleWithLink() : /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['title'], s['nowrap']),
        title: getDeviationTitle(deviation)
    }, getDeviationTitle(deviation));
    return /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['root'], className),
        alignItems: "flex-start"
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }, title, /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        className: classnames(s['author-block'], hasAuthor && s['has-author'])
    }, hasAuthor && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(UserAvatar, {
        size: 24,
        className: s['avatar'],
        user: deviation.author
    }), /*#__PURE__*/ React.createElement(UserLink, {
        user: deviation.author,
        className: classnames(s['userlink'], s['nowrap'])
    })), showTimestamp && /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: deviation.publishedTime,
        className: classnames(s['timestamp'], s['nowrap'])
    }))), /*#__PURE__*/ React.createElement(PriceBlock, priceProps));
};
PanelC33C.displayName = 'PanelC33C';
export default PanelC33C;
